// extracted by mini-css-extract-plugin
export default {"Wrapper":"DialogAddCard_Wrapper__CIQyZ","FieldItem":"DialogAddCard_FieldItem__nkgfw","SubmitBtn":"DialogAddCard_SubmitBtn__ZLdqy","Error":"DialogAddCard_Error__MGlaK"};